import ChatMessage from './styled';

export default ChatMessage;
